import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  constructor(@Inject(PLATFORM_ID) private platformId) { }

  ngOnInit(): void {
  }

  // tslint:disable-next-line:typedef
  onActivate(event) {
    if(isPlatformBrowser(this.platformId)) {
      window.scroll(0,0);
    }
  }
}
